import React, { useContext } from 'react';

export type CarouselContextType = {
    carouselName: string;
    carouselGuid: string;
};

const defaultCarouselContext = {
    carouselName: '',
    carouselGuid: '',
};

const CarouselContext = React.createContext<CarouselContextType>(
    defaultCarouselContext,
);

export const useCarouselContext = (): CarouselContextType =>
    useContext(CarouselContext);

export default CarouselContext;
